module.exports = __webpack_public_path__ + "static/heidenreich-846e8c0ab6e1591425936ccca88b4392.png";